import { useEffect, useState } from "react";

import { QuizStepProps } from "../useQuestionnaire";

import { Option } from "./components/Option";

const optionList = [
  { name: "<120/80 (Normal)", value: "Normal" },
  { name: "120-129/<80 (Elevated)", value: "Elevated" },
  { name: "130-139/80-89 (High Stage 1", value: "HighStage1" },
  { name: ">140/90 (High Stage 2)", value: "HighStage2" },
];

export const BloodPressure = (props: QuizStepProps) => {
  const [lastUpdate, setLastUpdate] = useState<{
    key: string;
    value: string;
  } | null>(null);

  const handleChange = (value: string) => {
    props.handleStepData("BloodPressure", value);
    setLastUpdate({ key: "BloodPressure", value });
  };

  useEffect(() => {
    if (props.next && lastUpdate) {
      props.next();
    }
  }, [lastUpdate]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div>
      <div className="pb-8 font-serif text-h3">
        What is your current or average blood pressure range?
      </div>
      <div>
        <div className="flex flex-wrap gap-3" key="BloodPressure">
          {optionList.map((option) => (
            <Option
              key={option.value}
              name={option.name}
              value={option.value}
              checked={props.data.BloodPressure === option.value}
              onChange={(e) => handleChange(option.value)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
